import BmiCalculator from "./TrackToolsComponent/BmiCalculator";
import CalorieCalculator from "./TrackToolsComponent/CalorieCalculator";
import { Link } from "react-scroll";
import bmi from "./images/Bmi-Image.jpg";
import calorieImage from "./images/calorie-image.webp";
import wiImage from "./images/wi-image.jpg";
import ceImage from "./images/ce-image.jpg";
import wtlImage from "./images/wtl-image.avif";
import WiCalculator from "./TrackToolsComponent/WiCalculator";
import CeCalculator from "./TrackToolsComponent/CeCalculator";
import WtlCalculator from "./TrackToolsComponent/WtlCalculator";
import { useAuth } from "./Context/AuthContext";
import { useState, useEffect } from "react";
import Axios from "axios";

function FitnessTools() {
  const { appUser, setUser, isLogin, setLogin } = useAuth();
  const [ftdata, setFtdata] = useState({});
  const [temp, setTemp] = useState(false);

  useEffect(() => {
    Axios.post("https://fitness-junction-bots.onrender.com/api/getftdata", {
      userEmail: appUser.email,
    })
      .then((response) => {
        console.log(response);
        setFtdata(response.data.ftdata);
        setTemp(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  function showBmiTool() {
    const tool = document.getElementById("bmiTool");
    //    const hideTools = document.getElementsByClassName('hide-tools');
    //    console.log(hideTools);
    document.getElementById("calorieTool").style.display = "none";
    document.getElementById("wiTool").style.display = "none";
    document.getElementById("ceTool").style.display = "none";
    document.getElementById("wtlTool").style.display = "none";
    tool.style.display = "block";
  }
  function showCalorieTool() {
    const tool = document.getElementById("calorieTool");
    tool.style.display = "block";
    document.getElementById("bmiTool").style.display = "none";
    document.getElementById("wiTool").style.display = "none";
    document.getElementById("ceTool").style.display = "none";
    document.getElementById("wtlTool").style.display = "none";
  }
  function showWiTool() {
    const tool = document.getElementById("wiTool");
    tool.style.display = "block";
    document.getElementById("bmiTool").style.display = "none";
    document.getElementById("calorieTool").style.display = "none";
    document.getElementById("ceTool").style.display = "none";
    document.getElementById("wtlTool").style.display = "none";
  }
  function showCeTool() {
    const tool = document.getElementById("ceTool");
    tool.style.display = "block";
    document.getElementById("bmiTool").style.display = "none";
    document.getElementById("calorieTool").style.display = "none";
    document.getElementById("wiTool").style.display = "none";
    document.getElementById("wtlTool").style.display = "none";
  }
  function showWtlTool() {
    const tool = document.getElementById("wtlTool");
    tool.style.display = "block";
    document.getElementById("bmiTool").style.display = "none";
    document.getElementById("calorieTool").style.display = "none";
    document.getElementById("wiTool").style.display = "none";
    document.getElementById("ceTool").style.display = "none";
  }

  return (
    <>
      <div className="container-fluid">
        <h2 className="main-heading tools-heading p-4">Fitness Tools</h2>
        <div className="predata-container">
          <h4 className="fw-medium mb-3">Previous Measured Values</h4>
          {temp ? (
            Object.keys(ftdata).length > 0 ? (
              Object.keys(ftdata).map((key, index) => (
                <div key={index}>
                  <label className="h5 fw-semibold">{key}:</label>
                  <span className="h5"> {ftdata[key]}</span>
                </div>
              ))
            ) : (
              <div>Fitness tools not used yet !!</div>
            )
          ) : (
            <></>
          )}
        </div>
      </div>

      <div className="fitness-container">
        {/* <h2 className="main-heading tools-heading">Fitness Tools</h2> */}
        {/* <div>
                {temp?Object.keys(ftdata).map((key, index) => (<div><label>{key} :&nbsp;</label><label>{ftdata[key]}</label></div>)):<></>}
            </div> */}
        <div className="fitness-tools exercise-cards">
          <div className="bmi-tool exercise-card">
            <Link
              onClick={showBmiTool}
              to="tool-section"
              spy={true}
              offset={50}
              duration={2000}
            >
              <img src={bmi} alt="" />
            </Link>
            <h2 className="exercise-title">Know Your BMI</h2>
          </div>

          <div className="calorie-tool exercise-card">
            <Link
              onClick={showCalorieTool}
              to="tool-section"
              spy={false}
              offset={50}
              duration={2000}
            >
              <img src={calorieImage} alt="" />
            </Link>

            <h2 className="exercise-title">Know Your Calories</h2>
          </div>

          <div className="wi-tool exercise-card">
            <Link
              onClick={showWiTool}
              to="tool-section"
              spy={false}
              offset={50}
              duration={2000}
            >
              <img src={wiImage} alt="" />
            </Link>

            <h2 className="exercise-title">Know Your Water Intake</h2>
          </div>

          <div className="ce-tool exercise-card">
            <Link
              onClick={showCeTool}
              to="tool-section"
              spy={false}
              offset={50}
              duration={2000}
            >
              <img src={ceImage} alt="" />
            </Link>

            <h2 className="exercise-title">Know Your Caloric Expenditure</h2>
          </div>

          <div className="wtl-tool exercise-card">
            <Link
              onClick={showWtlTool}
              to="tool-section"
              spy={false}
              offset={50}
              duration={2000}
            >
              <img src={wtlImage} alt="" />
            </Link>

            <h2 className="exercise-title">Know Your Correct Lifting Weight</h2>
          </div>
        </div>
        <div id="tool-section"></div>
        <div className="bmi-calculator hide-tools" id="bmiTool">
          <h1 className="main-heading">BMI Calculator</h1>
          <BmiCalculator />
        </div>

        <div className="calorie-calculator hide-tools" id="calorieTool">
          <h1 className="main-heading">Calorie Calculator</h1>
          <CalorieCalculator />
        </div>
        <div className="wi-calculator hide-tools" id="wiTool">
          <h1 className="main-heading">Water Intake Calculator</h1>
          <WiCalculator />
        </div>
        <div className="ce-calculator hide-tools" id="ceTool">
          <h1 className="main-heading">Caloric Expenditure Calculator</h1>
          <CeCalculator />
        </div>
        <div className="wtl-calculator hide-tools" id="wtlTool">
          <h1 className="main-heading">Correct Lifting Weight Calculator</h1>
          <WtlCalculator />
        </div>
      </div>
    </>
  );
}
export default FitnessTools;
